import React, { useRef } from "react";
import { Line } from "react-konva";
import { Line as LineType, LineConfig } from "konva/types/shapes/Line";
import { isTouchScreen } from "../../lib/elementUtilities";

interface IProps {
  points: number[];
  slotKey: string;
  buildingHover: (key: string) => void;
  buildingBlur: (key: string) => void;
  buildingClick: (elementRef: LineType<LineConfig> | null, key: string) => void;
}

const BuildingLine = ({
  points,
  slotKey,
  buildingHover,
  buildingBlur,
  buildingClick
}: IProps) => {
  const buildingLineRef = useRef<LineType<LineConfig>>(null);

  return (
    <Line
      ref={buildingLineRef}
      points={points}
      closed={true}
      onMouseEnter={() => !isTouchScreen() && buildingHover(slotKey)}
      onMouseLeave={() => !isTouchScreen() && buildingBlur(slotKey)}
      onClick={() => buildingClick(buildingLineRef.current, slotKey)}
      onTouchEnd={() => buildingClick(buildingLineRef.current, slotKey)}
    />
  )
}

export default BuildingLine;
